import styled from 'styled-components';

const Save = styled.button`
  flex: 1;
  border-radius: 3px;
  background-color: ${(props: any) => props.theme.carvana.blue.primary};
  color: ${(props: any) => props.theme.carvana.white.primary};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  height: 100%;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;

  :hover {
    background-color: ${(props: any) => props.theme.carvana.blue.hover};
  }

  :disabled {
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);
    border-radius: 3px;
    background-color: ${(props: any) => props.theme.carvana.gray.light};
    color: ${(props: any) => props.theme.carvana.gray.medium};
    cursor: not-allowed;
  }
`;

export default Save;
